/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


function initZoomAndPanSection(){
  const imageWrapper = document.querySelector(".animated-zoom__image-wrap")

  if (!imageWrapper) {
    return
  }

  document.querySelector(".animated-zoom").style.display = "block"

  const heightOfIamge = document.querySelector(".animated-zoom__img").clientHeight;
  const zoomWrap =  document.querySelector(".animated-zoom__zoom-wrap")
  const contentBoxes = document.querySelectorAll(".animated-zoom__slide-content-box")
  imageWrapper.style.height = `${heightOfIamge}px`
  let heightOfImage = document.querySelector(".js-height-of-image").offsetHeight
  
  const swiper = new Swiper('.animated-zoom__swiper', {  
    effect: 'fade',
    loop: false,
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  //  autoplay: {
  //    delay: 2800,
   //   stopOnLastSlide: true
  //  }, 
  });



  let contentBoxHeight = 0

  contentBoxes.forEach(function(box){
    if (box.offsetHeight > contentBoxHeight) {
      contentBoxHeight = box.offsetHeight
    }    
  })

  if (window.innerWidth < 1000) {
    document.querySelector(".animated-zoom").style.marginBottom = `${contentBoxHeight}px`    

    contentBoxes.forEach(function(box){
      box.style.top = `${heightOfImage - 20}px`
    })
  }
  
  const slides = document.querySelectorAll(".swiper-slide")
  const hotSpot = document.querySelectorAll(".js-hotspot")
  
  let vertPos = slides[0].dataset.vPos
  let horPos  = slides[0].dataset.hPos
  let hSvertPos = hotSpot[0].dataset.vPos
  let hShorPos  = hotSpot[0].dataset.hPos
  let zoom  = slides[0].dataset.zoom  
  zoomWrap.style.transform = `translate(${horPos}%, ${vertPos}%) scale(${zoom})`  
  
  hotSpot.forEach(function(e) {
    e.style.display = "none"
  });
  



  if (window.innerWidth < 1000) {
    setTimeout(function() {
      hotSpot[0].style.top = (hShorPos - 3) + "%"
      hotSpot[0].style.left = (hSvertPos - 2) + "%"
      hotSpot[0].style.display = "block"
    }, 1200);  
  }else{
    setTimeout(function() {
      hotSpot[0].style.top = hShorPos + "%"
      hotSpot[0].style.left = hSvertPos + "%"
      hotSpot[0].style.display = "block"
    }, 1200); 
  }
  
  swiper.on('slideChange', function (i) {  
    let self = this
    let vertPos = slides[this.activeIndex].dataset.vPos
    let horPos  = slides[this.activeIndex].dataset.hPos  
    let hSvertPos = hotSpot[this.activeIndex].dataset.vPos
    let hShorPos  = hotSpot[this.activeIndex].dataset.hPos  
    let zoom  = slides[this.activeIndex].dataset.zoom
    // let boxHeight = contentBoxes[this.activeIndex].offsetHeight

    // console.log(boxHeight);

    // contentBoxes[this.activeIndex].style.bottom = `-${boxHeight}px`

    zoomWrap.style.transform = `translate(${horPos}%, ${vertPos}%) scale(${zoom})`  
  
    hotSpot.forEach(function(e) {
      e.style.display = "none"
    });
  
    setTimeout(function() {
      hotSpot[self.activeIndex].style.top = hShorPos + "%"
      hotSpot[self.activeIndex].style.left = hSvertPos + "%"
      hotSpot[self.activeIndex].style.display = "block"
    }, 1200);  
  });  
}



function initProductVideoLightbox(){
  const videoLightbox = document.querySelector(".pswp--video")


  const btn = document.querySelectorAll(".product__zoom-button--video")
  const closeBtn = document.querySelectorAll(".pswp__button--video-close") 
  const zoomBtn = document.querySelectorAll(".product__zoom-button") 
  const normalClose = document.querySelector(".pswp__button--close")

 

  
  const pMedia = document.querySelector(".product__media") 
  const html = document.querySelector("html") 
  let video = document.querySelector(".pswp__img--video")  

  

  if (!normalClose) {
    return
  }

  normalClose.addEventListener('click', function (e) {
    pMedia.style.position =  'sticky' 

    setTimeout(function(){
      let wrapper = document.querySelector("product-image-zoom")
      wrapper.style.display = "none" 
     }, 2000);
  })



  zoomBtn.forEach((btn) => {
    btn.addEventListener('click', function (e) {

      let open = btn.getAttribute('aria-expanded')

      if (open) {
        pMedia.style.position =  'relative' 
      }else{
        pMedia.style.position =  'sticky'   
      }
    })
  })

  btn.forEach((btn) => {
    btn.addEventListener('click', function (e) {

      if (videoLightbox.hasAttribute('open')) {
        videoLightbox.classList.add('open-video')
        video.currentTime = 0;
        video.play()
        html.classList.add("lock-all")

      }else{
        videoLightbox.classList.remove('open-video')

        video.pause()
      }
    })
  })

  closeBtn.forEach((closeBtn) => {
    closeBtn.addEventListener('click', function (e) {
      if (videoLightbox.hasAttribute('open')) {
        videoLightbox.removeAttribute('open')  
        videoLightbox.classList.remove('open-video')
        html.classList.remove("lock-all")
        video.pause()      

      }
    })
  })







}

function initCustomColursPDP(){
  let colourOptions = document.querySelectorAll(".color-swatch")
  let customColours = []
  const colourSwatchWrap = document.querySelector(".js-custom-colours-wrap")

  colourOptions.forEach((swatch) => {
    if (swatch.hasAttribute('custom')) {
      swatch.style.display = "none"
      let dataId = swatch.getAttribute('data-id')
      let dataStyle = swatch.getAttribute('data-style')
      let dataLabel = swatch.getAttribute('data-label')
      customColours.push({"id": `${dataId}`, "style":`${dataStyle}`, "label":`${dataLabel}`})
    }
  })

  if (customColours.length) {
    customColours.forEach((colour) => {
      colourSwatchWrap.innerHTML = colourSwatchWrap.innerHTML + `
        <div class="color-swatch " >
          <input  class="color-swatch__radio visually-hidden" type="radio" >
          <label style="${ colour.style }" data-label="${colour.label}" data-id="${colour.id}" class="color-swatch__item js-custom-btn"  >
            <span class="visually-hidden">Duck Egg Blue</span>
          </label>
        </div>      
      `
    })

    let customBtn = document.querySelectorAll(".js-custom-btn")
    let colourLabel = document.querySelector(".js-Colour")
    let customColourLabel = document.querySelector(".js-cusom-colour-label")  

    customBtn.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        customBtn.forEach((btn) => {         
          btn.classList.remove('selected')
        })
        this.classList.add('selected')
        document.querySelector(`#${this.getAttribute('data-id')}`).click()
        colourLabel.innerHTML = this.getAttribute('data-label').replace("Custom Colour ", "")   
        // customColourLabel.innerHTML =  "Made to order (+£50) " 
      })
    })

    colourOptions.forEach((swatch) => {
      if (!swatch.hasAttribute('custom')) {
        swatch.addEventListener('click', function (e) {
          // customColourLabel.innerHTML = "None"   
          customBtn.forEach((btn) => {         
            btn.classList.remove('selected')
          })
        })  
      }
    })
  }
}

function initHeader(){
  const mobOpenBtn = document.querySelector(".js-mob-open-menu")
  const mobCloseBtn = document.querySelector(".js-close-mob-menu")
  const announcmentBar = document.querySelector(".shopify-section--announcement-bar")  
  const header = document.querySelector(".header")

  const promoBar = document.querySelector(".promotional-bar")    
  const stickyAdd = document.querySelector(".product-sticky-form")   

  



  let lastScrollTop = 0;

  window.onscroll = function(e) {
    let st = window.pageYOffset;




    if (st > lastScrollTop && st > 100){
      announcmentBar.classList.add('header-hidden')
      header.classList.add('header-hidden')
      header.classList.add('header-shrink')

      document.querySelector('#shopify-section-header').style.pointerEvents = "none"



      if (stickyAdd) {
        stickyAdd.classList.add('top')
      }
 


      let menus = document.querySelectorAll('.mega-menu')
      menus.forEach((menu) => {
        menu.style.top = "79px"
      })

      document.querySelector('#mobile-menu-drawer').style.top = "78px"      
    
  
    } else {     
      header.classList.remove('header-hidden')
      announcmentBar.classList.remove('header-hidden')
      document.querySelector('#shopify-section-header').style.pointerEvents = "all"
 

      if (stickyAdd) {
        stickyAdd.classList.remove('top')
      }
  
      // document.querySelector('#shopify-section-header').style.pointerEvents = "auto"
    
    }

    if (st < 100){
      header.classList.remove('header-shrink')

      document.querySelector('#mobile-menu-drawer').style.top = "160px"

      let menus = document.querySelectorAll('.mega-menu')



      menus.forEach((menu) => {
        menu.style.top = "100%"
      })
    }








    lastScrollTop = st;
  }


  mobOpenBtn.addEventListener('click', function (e) {
    mobOpenBtn.style.display = "none"
    mobCloseBtn.style.display = "block"
  })

  mobCloseBtn.addEventListener('click', function (e) {
    mobOpenBtn.style.display = "block"
    mobCloseBtn.style.display = "none"
  })
}

function initSliderMods(){
  const imageHeight = document.querySelectorAll(".slideshow__image")
  const btns = document.querySelector(".slide-show-btns") 
  const wrappers = document.querySelectorAll('slide-show')

  const product = document.querySelector('.template-product')

  if (!imageHeight.length) {
    return;
  }

  if (!btns) {
    return;
  }

  console.log(product);

  if (product == null) {
    console.log('go');
    wrappers.forEach((wrap) => {
      console.log(wrap);
      let imgHeight = wrap.querySelector('slide-show-item').offsetHeight
      let textHeight = wrap.querySelectorAll('.mobile-slide-show')[0].offsetHeight 
  
      console.log(textHeight);
  
      wrap.style.height = `${ imgHeight  + textHeight}px`
      console.log(imgHeight);
  
    } )
  }






  console.log('here');

  btns.style.opacity = `1` 
  btns.style.top = `${imageHeight[0].offsetHeight - 42}px` 

}

function initFooter(){
  const btns = document.querySelectorAll(".footer__item--links") 

  btns.forEach((btn) => {
    btn.addEventListener('click', function (e) {

      btn.classList.add('active')


    })
  })
  
}

function initPdpTabs(){



  

  let wrapper = document.querySelectorAll(".product-tabs-wrapper")


  wrapper.forEach((tab) => {

    let tabs = tab.querySelectorAll(".product-tabs-menu__item")
    let runner = tab.querySelector(".product-tabs-menu__runner-tab")
    let content = tab.querySelectorAll(".product-tabs__tab")

    tabs.forEach((btn) => {
      btn.addEventListener('click', function (e) {


        tabs.forEach((tab) => {
          tab.classList.remove('active')
        })

        let position = btn.getBoundingClientRect();
        btn.classList.add('active')
        let left = position.x
        let width = position.width

        runner.style.left = `${left}px`
        runner.style.width = `${width}px`

        //select the tab
        let btnAttr = btn.getAttribute('data-tab')

        content.forEach((cTab) => {
          let contentAttr = cTab.getAttribute('data-tab')


          if(contentAttr == btnAttr){
            cTab.classList.add('active')
            

            setTimeout(function() {
              cTab.style.opacity = '1'
            }, 400);

          }else{
            cTab.style.opacity = '0'
            
            setTimeout(function() {
              cTab.classList.remove('active')
            }, 00);
          }
        })
      })
    })



    if (!tabs[0].parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains('product-tabs-wrapper--cevoid')) {
      tabs[0].click()
    }

    

  })
  
  
}

function initPdpFaqs(){
  const btns = document.querySelectorAll(".faqs__question")


  btns.forEach((btn) => {

    btn.addEventListener('click', function(){
      let answer = btn.parentNode.querySelector(".faqs__answer")

 
      if (!answer.classList.contains('active')) {
        answer.classList.add('active')
        btn.classList.add('active')
        answer.style.opacity = '1'

      }else{
        answer.classList.remove('active')
        btn.classList.remove('active')
        answer.style.opacity = '0'
      }




    })
  })
}

  var moneyFormat = window.themeVariables.settings.moneyFormat  // Retrieves the moneyFormat variable using the window.themeVariables.settings object
  var currencySymbol = moneyFormat.match(/\$|£|€|¥|₹/)[0]  // Uses regular expression to match the currency symbol in the moneyFormat string (can add more symbols as needed). Then stores the matched currency symbol in the currencySymbol variable.
 //console.log(currencySymbol)   


function initProductUpsells(){

  if (!document.querySelector(".product-meta__price-list-container .price--large")) {
    return
  }


  let ajustedPrice = parseFloat(document.querySelector(".product-meta__price-list-container .price--large").innerText.replace("Sale price", "").replace("£", "").replace("$", "").replace("€", "").replace(",", "").replace(".", "")) // added .replace("$", "") in all instances of adjusted and var price.
  let dummyPrice = document.querySelectorAll(".js-price")

  let hasComparioson = document.querySelector('.product-meta__price-list-container').querySelector('.price--compare')

  dummyPrice.forEach(function(price){
    // price.innerText = `£${(ajustedPrice / 100).toFixed(2)}` // displays if No extras or custom colour added. Old code with just '£' showing. 
    price.innerText = `${currencySymbol}${(ajustedPrice / 100).toFixed(2)}` // displays if No extras or custom colour added. currencySymbol taken from var code above the function initProductUpsells.
    price.setAttribute('price', ajustedPrice)

    if(hasComparioson){
      let comparison = hasComparioson.innerText
      let p = document.createElement('p')
      p.append(comparison)
      price.append(p)
      p.style.fontSize = '18px'
      p.classList.add('compare-price')
    }
  })


  const quickSellBtns = document.querySelectorAll(".product-item__quick-buy-button--upsell")
  const upsellCards = document.querySelectorAll(".product-item--upsell")
  let noVarsButtons = document.querySelectorAll(".js-upsell-no-vars")
  const cardRemoveBtns = document.querySelectorAll(".js-upsell-remove")
  const showOptions = document.querySelectorAll(".js-upsell-show-options")
  const buyButton = document.querySelector("#AddToCart")
  let items = []
  let productsAdded = []

  let mainPrdocutChange = document.querySelector(".js-var-id")

  mainPrdocutChange.addEventListener('change', function(){
    // let ajustedPrice = parseFloat(document.querySelector(".product-meta__price-list-container .price--large").innerText.replace("Sale price", "").replace("£", "").replace("$", "").replace("€", "").replace(",", "").replace(".", ""))
    // let dummyPrice = document.querySelectorAll(".js-price")

    // dummyPrice.forEach(function(price){
    //   price.innerText = `£ ${(ajustedPrice / 100).toFixed(2)}`
    //   price.setAttribute('price', ajustedPrice)
    // })
    setTimeout(function() {
      updateDummyPrice()
    }, 500);

    // console.log('changeddd');
  })



  function updateDummyPrice(){
    let dummyPrice = document.querySelectorAll("product-payment-container .js-price")
    let originalprice = parseInt(dummyPrice[0].getAttribute('price'))
    let addedPrice = 0



    if (isNaN(originalprice)) {
      originalprice = parseInt(dummyPrice[1].getAttribute('price'))
    }

    if (isNaN(originalprice)) {
      originalprice = parseInt(dummyPrice[2].getAttribute('price'))
    }

    productsAdded.forEach((price => {
      addedPrice = addedPrice + price.price
    }))

    let hasComparioson = document.querySelector('.product-meta__price-list-container').querySelector('.price--compare')

    dummyPrice.forEach(function(price){
      //price.innerText = `£${((originalprice + addedPrice) / 100).toFixed(2)}` // displays if extras or custom colour added. Old code that displayed '£' only.
      price.innerText = `${currencySymbol}${((originalprice + addedPrice) / 100).toFixed(2)}` // displays if extras or custom colour added. currencySymbol taken from var code above the function initProductUpsells.
     price.setAttribute('price', ajustedPrice) // added to fix issue of NaN displaying for price when more than 2 extras added when country other than UK is selected.
      
      if(hasComparioson){
        let comparison = hasComparioson.innerText
        let p = document.createElement('p')
        p.append(comparison)
        price.append(p)
        p.style.fontSize = '18px'
        p.classList.add('compare-price')
      }
    })





  }

  showOptions.forEach((button) => {

    button.addEventListener('click',function(){
      let wrapper = button.parentNode.parentNode.parentElement
      let thisQSBtn = wrapper.querySelectorAll(".product-item__quick-buy-button--upsell")

      thisQSBtn.forEach((button) => {
        button.click()
      })
      
    })

  })


  cardRemoveBtns.forEach((button) => {
    button.addEventListener('click', function(){
      let product = button.getAttribute('data-p-title')

      upsellCards.forEach((card) => {
        let title = card.querySelectorAll(".product-item-meta__title")
  
        if (title[0].innerHTML == product) {  
          card.classList.remove('selected')
  
          //remove variant from array
          productsAdded.forEach((obj, pIndex) => {
            if (obj.product == product) {
              let varientId = obj.id
  
              items.forEach((item, index) => {
                if (item.id == varientId) {
                  items.splice(index, 1)
                  productsAdded.splice(pIndex, 1)
                  button.parentNode.parentNode.parentElement.classList.remove('selected')
                  buyButton.setAttribute('upsells', JSON.stringify(items) )
                }
              })
            }
          })
        }

        updateDummyPrice()
      })

      let quickView = document.querySelectorAll(".drawer__content")    
    
      quickView.forEach((wrapper) => {
        wrapper.style.opacity = 0
      })
    })
  })

  noVarsButtons.forEach((noVarsButton) => {
    noVarsButton.addEventListener('click', function(){
      let varId = noVarsButton.getAttribute('data-var-id')
      let product = noVarsButton.getAttribute('data-p-title')
      let varPrice = parseInt(noVarsButton.getAttribute('data-var-price'))

      noVarsButton.parentNode.parentNode.parentElement.classList.add('selected')
  
      items.push({          
        "id": parseInt(varId) ,
        "quantity":
         1
      })  
      productsAdded.push({
        "product": product,
        'id': parseInt(varId),
        'price': varPrice
      })

      updateDummyPrice()

      buyButton.setAttribute('upsells', JSON.stringify(items) )
    })
  })


  quickSellBtns.forEach((btn) => {
    btn.addEventListener('click', function(){

      setTimeout(function() {
        let ypp = document.querySelectorAll(".drawer--quick-buy, .popover--quick-buy")
        // let mobilePopup = quick-buy-popover
        ypp.forEach((wrapper) => {
          if (wrapper.hasAttribute("open")) { 

            if (!btn.parentNode.parentNode.parentNode.classList.contains('selected')) {
              listenForVarient(wrapper, true)
            }else{
              listenForVarient(wrapper)
            }
          }
        })
      }, 1500);
    })
  })

  function listenForVarient(variant, notSelected){    
    let form = variant.querySelector(".product-form")
    let varIdInput = variant.querySelector(".js-var-id")
    let varId = varIdInput.value
    let thisProductTitle = variant.querySelector(".product-item-meta__title")


    let varPrice = parseFloat(variant.querySelector(".price").innerText.replace("Sale price", "").replace("£", "").replace("$", "").replace("€", "").replace(",", "").replace(".", ""))



    varIdInput.addEventListener('change', function(){
      varId = varIdInput.value

      setTimeout(function() {
        varPrice = parseFloat(variant.querySelector(".price").innerText.replace("Sale price", "").replace("£", "").replace("$", "").replace("€", "").replace(",", "").replace(".", ""))
      }, 200);


    })

    let upsellBtn = variant.querySelector(".add")
    let upsellBtnAdded = variant.querySelector(".added")


    if (upsellBtnAdded && !notSelected) {
      upsellBtnAdded.remove()
      let button = document.createElement("button")
      button.classList.add('button', 'button--primary', 'add', 'upsell-btn')
      button.append("+ Selected")
      form.append( button)   


      button.addEventListener('click',function(){
        button.classList.remove('added')
        variant.querySelector(".drawer__close-button").click()   
        
        upsellCards.forEach((card) => {
          let title = card.querySelectorAll(".product-item-meta__title")

          if (title[0].innerHTML == thisProductTitle.innerHTML) {  
            card.classList.remove('selected')

            //remove variant from array
            productsAdded.forEach((obj, pIndex) => {
              if (obj.product == thisProductTitle.innerHTML) {
                let varientId = obj.id

                items.forEach((item, index) => {
                  if (item.id == varientId) {
                    items.splice(index, 1)
                    productsAdded.splice(pIndex, 1)
                    buyButton.setAttribute('upsells', JSON.stringify(items) )
                  }
                })
              }
            })
          }
        })

        updateDummyPrice()

        button.remove()



      })


    }else{

      if(!upsellBtn){
        let button = document.createElement("button")
        button.classList.add('button', 'button--primary', 'add', 'upsell-btn')
        button.append("+ Select")
        form.append( button)
 
    
        button.addEventListener('click',function(){

          items.push({          
            "id": parseInt(varId) ,
            "quantity": 1
          })  
          productsAdded.push({
            "product": thisProductTitle.innerHTML,
            'id': parseInt(varId),
            'price': varPrice
          })
      
          updateDummyPrice()
    
          buyButton.setAttribute('upsells', JSON.stringify(items) )

          button.classList.add('added')
          variant.querySelector(".drawer__close-button").click()   
          
          upsellCards.forEach((card) => {
            let title = card.querySelectorAll(".product-item-meta__title")
            if (title[0].innerHTML == thisProductTitle.innerHTML) {  
              card.classList.add('selected')
            }else{
     
            }
          })
        })
      }
    }

    let quickView = document.querySelectorAll(".drawer__content")   
    
    quickView.forEach((wrapper) => {
      wrapper.style.opacity = 1
    })
  }
}


function initDragableSubs(){


  const slider = document.querySelector('.upsells__inner');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (!slider) {
      return
    }

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;

    });
}

function initBusinessEquiryForm(){
  

  let formButton = document.querySelectorAll(".js-open-enquire-form")
  let formCloseButton = document.querySelector(".js-close-enquire-form")

  



  if (!formCloseButton) {
    return
  }

  
  let form = document.querySelector(".enquire-contact-form")
  let formInner = document.querySelector(".enquire-contact-form__inner")
  let overlay =  document.querySelector(".enquire-contact-form-overlay")
  let formWrap = document.querySelector(".contact__form--enquire")



  if (document.body.classList.contains('outside-uk')) {
    // do some stuff
    let hidden = `<input hidden id="contact-form-international" type="text" class="input__field" name="contact[International]" aria-label=""  value="international-equiry-redirect">`
    formWrap.innerHTML = hidden + formWrap.innerHTML;
  }
  

  formButton.forEach((btn) => {

    btn.addEventListener('click', function(){
      form.classList.add('active')

      console.log('clickwed');

      overlay.classList.add('active')


      setTimeout(function() {
        formInner.style.opacity = 1
      }, 400);

    })
  })

  formCloseButton.addEventListener('click', function(){
    

    formInner.style.opacity = 0


    setTimeout(function() {
      form.classList.remove('active')
      overlay.classList.remove('active')
    }, 400);
  })

  if (window.location.href.includes('contact_posted=true')){
    form.classList.add('active')
    overlay.classList.add('active')

    setTimeout(function() {
      formInner.style.opacity = 1
    }, 400);
  }

  
}





function initCevoidCheck(){

  const checkForAffirm = window.setInterval(function(){
    checkIfAffirm()
  }, 50);
  

  function checkIfAffirm() {

    let appLoaded = document.querySelector('#cevoid-container')



    if (appLoaded) {
      clearInterval(checkForAffirm)   
      appLoaded.append("TESTINGG")
      var pashleyImage = document.createElement("img");
      pashleyImage.src = "https://cdn.shopify.com/s/files/1/2999/8836/files/Fill-158.png?v=1661411453";
      pashleyImage.classList.add('gallery-over-image')
      appLoaded.parentNode.append(pashleyImage)
    }else{

    }
  } 
}


function initTheDesign(){
  console.log('hello!');

  const swiper = new Swiper('.the-design__inner', {
    // Optional parameters
    effect: "fade",

    pagination: {
      el: '.the-design__pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        console.log('testing btn');

        let btn = document.querySelector(`.the-design__button--${index}`).innerHTML

        


        return `<span class="dot swiper-pagination-bullet">${btn}</span>`;
      },
    }  

  });
}




initProductVideoLightbox()
initCustomColursPDP()
initHeader()
initSliderMods()
initFooter()
initPdpTabs()
initPdpFaqs()
initProductUpsells()
initDragableSubs()
initBusinessEquiryForm()
initCevoidCheck()
initTheDesign()

window.addEventListener('resize', function(event) {
  // initPdpTabs()
  // initZoomAndPanSection()
}, true);



setTimeout(function() {
  initZoomAndPanSection()
}, 3000);

